var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "englishFlagClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#englishFlagClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#00247d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 60,60 M60,0 0,60",
    stroke: "#ffffff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 24,24 M60,0 36,24 M0,60 24,36 M60,60 36,36",
    stroke: "#cf142b",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v60 M0,30 h60",
    stroke: "#ffffff",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 v60 M0,30 h60",
    stroke: "#cf142b",
    strokeWidth: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.fd4ccf2434cdfc2c2386046c614ff098.svg";
export { ForwardRef as ReactComponent };